import React, { Component } from "react";
import { ToastContainer } from "react-toastify";
import toast from "../helpers/toast";
import Httpconfig from "../helpers/Httpconfig";
import Constant from "../../constants";
import { MDBDataTable, MDBBadge, MDBContainer } from "mdbreact";
import DiagnosisHeader from "../diagnostics/DiagnosisHeader";
import DiagnosisMenu from "../diagnostics/DiagnosisMenu";
import { Link } from "react-router-dom";
import * as SecureLS from "secure-ls";
import constants from "../../constants";

var ls = new SecureLS({
  encodingType: "aes",
  encryptionSecret: "medleymed",
});

export default class ViewDiagnosticsCategories extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page_data: "",
      datatable: {
        columns: [
          { label: "Category Name", field: "category_name", sort: "asc", width: 270 },
          { label: "Status", field: "status", sort: "asc", width: 150 },
          { label: "Actions", field: "actions", sort: "asc", width: 150 },
        ],
        rows: [],
      },
      diagnosisId: "",
      highlightId: null,
    };
    this.deleteCategory = this.deleteCategory.bind(this);
  }

  // To get details after first render
  componentDidMount = () => {
    let userData = ls.get("diagnosisObj");
    
    if (userData) {
      if (userData != "") {
        this.setState({
          diagnosisId: userData.diagnosis_id,
        });
        this.forceUpdate();
      }
    }
    // Removed redirect - allow viewing without login
    
    // Check if there's a highlighted category from redirect
    const highlightId = this.props.location?.state?.highlightId;
    if (highlightId) {
      this.setState({ highlightId });
    }
    
    this.fetchCategoriesData();
  };

  // When value changes of the fields
  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  // Update status for category
  updateStatus(id, status) {
    const newStatus = status === 1 ? 0 : 1;
    
    Httpconfig.httptokenput(
      constants.siteurl + "api/DIAGNOSIS/diagnosiscategory/" + id + "/status",
      { status: newStatus }
    )
      .then((response) => {
        if (response.data && response.data.status === 200) {
          toast.success("Status updated successfully");
          setTimeout(() => this.fetchCategoriesData(), 1000);
        } else {
          toast.error(response.data.message || "Failed to update status");
        }
      })
      .catch((error) => {
        console.error("Error updating status:", error);
        toast.error("Failed to update status");
      });
  };

  // For getting the data
  fetchCategoriesData() {
    console.log("Fetching categories from:", constants.siteurl + "api/DIAGNOSTIC/testcategories");
    
    Httpconfig.httptokenget(constants.siteurl + "api/DIAGNOSTIC/testcategories")
      .then((response) => {
        console.log("✅ Categories Response:", response.data);
        const categories = Array.isArray(response.data.data) ? response.data.data : [];
        console.log("✅ Categories array:", categories);
        
        if (categories.length === 0) {
          console.warn("⚠️ No categories found in response");
        }
        
        let assignvalues = [];

        categories.forEach((cat) => {
          console.log("Processing category:", cat);
          const isHighlighted = this.state.highlightId && cat.id === this.state.highlightId;
          
          // Map the API response fields: id, name, status
          assignvalues.push({
            category_name: (
              <span
                id={`category-${cat.id}`}
                style={{
                  backgroundColor: isHighlighted ? "#ffffcc" : "transparent",
                  padding: isHighlighted ? "5px 10px" : "0",
                  borderRadius: isHighlighted ? "4px" : "0",
                  display: "inline-block",
                  fontWeight: isHighlighted ? "bold" : "normal",
                  transition: "all 0.3s ease"
                }}
              >
                {cat.name || "N/A"}
              </span>
            ),
            status:
              cat.status === "active" ? (
                <MDBBadge
                  color="success"
                  style={{ cursor: "pointer" }}
                >
                  Active
                </MDBBadge>
              ) : (
                <MDBBadge
                  color="warning"
                  style={{ cursor: "pointer" }}
                >
                  Inactive
                </MDBBadge>
              ),
            actions: (
              <div>
                <span>
                  <Link
                    to={"/diagnostics/DiagnosticsCategories/" + cat.id}
                    className="fa fa-edit point-cursor"
                    title={"Edit " + cat.name}
                  />
                </span>
                &nbsp;
                <span>
                  <i
                    onClick={() => this.deleteCategory(cat.id, cat.name)}
                    className="fa fa-trash point-cursor"
                    title={"Delete " + cat.name}
                    style={{ cursor: "pointer" }}
                  />
                </span>
                &nbsp;
              </div>
            ),
          });
        });

        console.log("✅ Mapped values:", assignvalues);
        console.log("✅ Setting state with rows:", assignvalues.length);
        console.log("📊 Current datatable state before update:", this.state.datatable);

        this.setState({
          datatable: {
            ...this.state.datatable,
            rows: assignvalues
          }
        }, () => {
          console.log("✅ State updated, current rows:", this.state.datatable.rows.length);
          console.log("📊 Full datatable state after update:", this.state.datatable);
          console.log("📋 Columns:", this.state.datatable.columns);
          
          // Scroll to the highlighted category after render
          if (this.state.highlightId) {
            setTimeout(() => {
              const element = document.getElementById(`category-${this.state.highlightId}`);
              if (element) {
                element.scrollIntoView({ 
                  behavior: "smooth", 
                  block: "center" 
                });
                
                // Remove highlight after 3 seconds
                setTimeout(() => {
                  this.setState({ highlightId: null });
                }, 3000);
              }
            }, 500);
          }
        });
      })
      .catch((error) => {
        console.error("❌ Error fetching categories:", error);
        toast.error("Failed to fetch categories");
      });
  }

  // Delete category
  deleteCategory(catId, name) {
    var isConfirm = window.confirm("Are you sure you want to delete " + name + "?");
    if (isConfirm) {
      const categoryIdNum = Number(catId);
      Httpconfig.httptokendelete(
        constants.siteurl + "api/DIAGNOSTIC/test-type/delete/" + categoryIdNum,
      )
        .then((response) => {
          console.log("Delete category response:", response);
          if (response.data && (response.data.status === 200 || response.data.status === 204) && response.data.error === false) {
            toast.success("Category deleted successfully");
            setTimeout(() => this.fetchCategoriesData(), 1000);
          } else if (response.data && response.data.error === true) {
            toast.error(response.data.message || "Failed to delete category");
          } else {
            toast.success("Category deleted successfully");
            setTimeout(() => this.fetchCategoriesData(), 1000);
          }
        })
        .catch((error) => {
          console.error("Error deleting category:", error);
          const errorMessage = error.response?.data?.message || error.message || "Failed to delete category";
          toast.error(errorMessage);
        });
    }
  }

  render() {
    const { datatable } = this.state;
    console.log("🎨 Rendering with datatable rows:", datatable.rows.length);
    console.log("🎨 Rendering with datatable columns:", datatable.columns.length);
    console.log("🎨 Full datatable object:", datatable);
    
    return (
      <main id="main">
        <DiagnosisHeader />
        <DiagnosisMenu />
        <section id="Pharmacy_dashboard">
          <div className="Pharma_Content">
            <div className="container-fluid">
              <div className="create-coupon-page">
                <div className="row">
                  <div className="col-md-12">
                    <form>
                      <div className="tab-header create-coupon-header">
                        <h3>Diagnostics Categories</h3>
                        <Link
                          to="/diagnostics/DiagnosticsCategories"
                          className="btn btn-primary fright"
                        >
                          Create Category
                        </Link>
                      </div>
                    </form>
                  </div>
                </div>
                <div className="row">
                  <div id="" className="viewcoupons">
                    {datatable.rows.length === 0 ? (
                      <p>No Categories found</p>
                    ) : (
                      <MDBDataTable
                        responsive
                        striped
                        bordered
                        small
                        data={datatable}
                        paging={true}
                        searching={true}
                        displayEntries={true}
                        entries={10}
                        entriesOptions={[5, 10, 20, 50]}
                        info={true}
                        noBottomColumns={false}
                      />
                    )}
                    
                    <div className="row">
                      <div className="col-md-12">
                        <div
                          className="update_btn"
                          style={{ textAlign: "right" }}
                        ></div>
                      </div>
                    </div>
                    <ToastContainer />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    );
  }
}
